import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersApi,
  partnersApiKeys,
  type CreatePartnerAccountRequest,
} from '@/api/routes/partners/partners.api';

/** The onboarding form owns the error UX (field errors and the inline alert). */
export const usePartnersSignup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreatePartnerAccountRequest) => partnersApi.signup(data),
    meta: { showUserMessage: false },
    onSuccess: (response) => {
      queryClient.setQueryData(partnersApiKeys.me(), response.data);
      return queryClient.invalidateQueries({ queryKey: partnersApiKeys.all });
    },
  });
};
